/* eslint-disable no-useless-escape */

export const PASSWORD_ALLOWED_SPECIAL_CHARACTERS = '=+\\-^$*.\\[\\]{}()?"!@#%&/\\,><\\\':;|_~`';

// eslint-disable-next-line max-len
export const PASSWORD_REGEXP = `^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[${PASSWORD_ALLOWED_SPECIAL_CHARACTERS}])[A-Za-z\\d${PASSWORD_ALLOWED_SPECIAL_CHARACTERS}&]{12,99}$`;

export const EMAIL_REGEXP = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
